import { render, staticRenderFns } from "./ProjectProductForm.vue?vue&type=template&id=3b373a14"
import script from "./ProjectProductForm.vue?vue&type=script&lang=js"
export * from "./ProjectProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports